import { render } from "./ForgotPasswordSuccess.vue?vue&type=template&id=508a226c"
import script from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricardo/Sites/customizer/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__